import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import "./Navbar.css";

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [academicsDropdown, setAcademicsDropdown] = useState(false);
  const [campusesDropdown, setCampusesDropdown] = useState(false);
  const location = useLocation();

  const toggleMenu = () => setIsOpen(!isOpen);
  const closeMenu = () => {
    setIsOpen(false);
    setAcademicsDropdown(false);
    setCampusesDropdown(false);
  };

  // Add shadow on scroll
  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 10);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Detect mobile screen dynamically
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <header className={`navbar ${isScrolled ? "scrolled" : ""}`}>
      <div className="navbar-container">
        {/* Logo */}
        <div className="navbar-logo">
          <Link to="/" onClick={closeMenu} className="logo-link">
            <img
              src="/images/logo.webp"
              alt="School Logo"
              className="logo-img"
            />
          </Link>
        </div>

        {/* Navigation Links */}
        <nav className={`nav-links ${isOpen ? "open" : ""}`}>
          {/* Home */}
          <Link
            to="/"
            className={location.pathname === "/" ? "active" : ""}
            onClick={closeMenu}
          >
            Home
          </Link>

          {/* About */}
          <Link
            to="/about"
            className={location.pathname === "/about" ? "active" : ""}
            onClick={closeMenu}
          >
            About
          </Link>

          {/* Academics Dropdown */}
          <div
            className={`dropdown ${academicsDropdown ? "open" : ""}`}
            onMouseEnter={() => !isMobile && setAcademicsDropdown(true)}
            onMouseLeave={() => !isMobile && setAcademicsDropdown(false)}
          >
            <span
              className={`dropbtn ${
                location.pathname.includes("/academics") ? "active" : ""
              }`}
              onClick={() =>
                isMobile && setAcademicsDropdown(!academicsDropdown)
              }
            >
              Academics ▾
            </span>
            {academicsDropdown && (
              <div className="dropdown-content">
                <Link to="/academics/primary" onClick={closeMenu}>
                  Primary School
                </Link>
                <Link to="/academics/middle" onClick={closeMenu}>
                  Middle School
                </Link>
                <Link to="/academics/high" onClick={closeMenu}>
                  High School
                </Link>
              </div>
            )}
          </div>

          {/* Campuses Dropdown */}
          <div
            className={`dropdown ${campusesDropdown ? "open" : ""}`}
            onMouseEnter={() => !isMobile && setCampusesDropdown(true)}
            onMouseLeave={() => !isMobile && setCampusesDropdown(false)}
          >
            <span
              className={`dropbtn ${
                location.pathname.includes("/campuses") ? "active" : ""
              }`}
              onClick={() => isMobile && setCampusesDropdown(!campusesDropdown)}
            >
              Campuses ▾
            </span>
            {campusesDropdown && (
              <div className="dropdown-content">
                <Link to="/campuses/boys" onClick={closeMenu}>
                  Boys Branch
                </Link>
                <Link to="/campuses/girls" onClick={closeMenu}>
                  Girls Branch
                </Link>
                <Link to="/campuses/rangilpur" onClick={closeMenu}>
                  Rangilpur Branch
                </Link>
              </div>
            )}
          </div>

          {/* Gallery */}
          <Link
            to="/gallery"
            className={location.pathname === "/gallery" ? "active" : ""}
            onClick={closeMenu}
          >
            Gallery
          </Link>

          {/* Admissions */}
          <Link
            to="/admissions"
            className={location.pathname === "/admissions" ? "active" : ""}
            onClick={closeMenu}
          >
            Admissions
          </Link>

          {/* Contact */}
          <Link
            to="/contact"
            className={location.pathname === "/contact" ? "active" : ""}
            onClick={closeMenu}
          >
            Contact
          </Link>

          {/* Login */}
          <Link to="/login" onClick={closeMenu} className="login-btn">
            Login
          </Link>
        </nav>

        {/* Hamburger Menu */}
        <div
          className={`hamburger ${isOpen ? "open" : ""}`}
          onClick={toggleMenu}
          aria-label="Toggle menu"
          role="button"
          tabIndex={0}
          onKeyDown={(e) => e.key === "Enter" && toggleMenu()}
        >
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </header>
  );
}

export default Navbar;
